// The trace a surface outside the tab asks about -- the influence overlay,
// armed with a turn index against the panel's axis and holding the request's
// id. A trace's axis is the session's record up to the request (its newest
// page comes with getTrace, see apiClient), so the open tab's data is the
// answer when the tab has rendered -- the tab is keyed by its address, the
// data by the request -- and getTrace's is the same axis when it has not.
export async function resolveTrace(traceId, { tabs, query }) {
    const open = tabs.find((t) => t.type === "trace" && (t.id === traceId || t.data?.id === traceId));
    if (open?.hydrated && !open.loading && open.data) return open.data;
    return (await query("getTrace", { id: traceId })) || null;
}
